"use client";

import { cn } from "@/shared/libs/commonUtils";
import Flex from "./Flex";
import PhosphorIcon from "./PhosphorIcon";
import useScroll from "@/shared/hooks/useScroll";

interface BackToTopProps {
  position?: "left" | "right";
}

export default function BackToTop({ position = "left" }: BackToTopProps) {
  const { distanceFromTop } = useScroll();

  const handleBackToTop = () => {
    scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <Flex
      alignItems={"center"}
      justifyContent={"center"}
      className={cn(
        "size-10 bottom-10 fixed rounded-full bg-background ring-1 ring-ring cursor-pointer hover:shadow-1 transition-[opacity_transform] duration-[0.7_1] ease-ease-in-out-back",
        position === "right"
          ? "right-0 -translate-x-full"
          : "left-0 translate-x-full",
        distanceFromTop < 500 ? "opacity-0 -bottom-10" : "",
      )}
      onClick={handleBackToTop}
    >
      <PhosphorIcon
        name="CaretUp"
        size={20}
        className="text-muted-foreground"
      />
    </Flex>
  );
}
